import _ from 'underscore'
import $ from 'jquery'
import {
    convertInputToDateTime,
    formatDate,
    parseDate,
    postRenderImages,
} from 'util/twistle'
import {
    raiseAlert
} from "util/alert_util"

import { ajax } from 'util/ajax'
import { betterFormatDate } from 'util/date'
import { escapeHTML } from "util/string"
import { localize } from 'util/localize'
import { isHandheld } from 'util/breakpoints'
import { renderTemplate } from 'util/template_renderer'
import { showGrowlDefault } from 'util/alerts'
import Contact from 'app/models/contact'
import DialogView from 'app/views/dialog_view'

App.WorkflowStartExecutionDialogView = DialogView.extend({
    className: "workflow_dialog",
    initialize: function(options) {
        const self = this;
        self.options = _.extend({}, self.options, options, {
            title: "Start a Twistle Workflow",
            width:Math.min($(window).width()-40,620),
            height:"auto",
            trueModal:false,
            position:{my:"center center-40",at:"center center",of:$(window)},
            dialogClass:"dialog_panel workflow_dialog_panel",
            overlayClass: "attachment_dialog_overlay",
            nextButtonText: !isHandheld() ? "Start Workflow" : undefined,
            showVisibleWorkflowOnly: true
        });

        DialogView.prototype.initialize.call(self, self.options);

        self.render();

    },

    events:function(){
        return _.extend({}, DialogView.prototype.events() || {}, {
            'change input': 'validateForm',
            'keyup input': 'validateForm',
            'keyup textarea': 'validateForm',
            'keyup input.workflow_definition_input': 'updateWorkflowChooser', // see App.WorkflowChooserMixin
            'click .workflow_definition_option':'workflowDefChosen',
            'click .show_default_actors':'toggleDefaultActors',
            'click .use_current_start_on_date':'useCurrentStartDate',
            'click .cancel_form': 'hide',
            'click .submit_form': 'submitForm',
            'click .form_submission_manage_button': 'manageForm',
            'click .batch_invite_button': 'startBatchUpload'
        });
    },

    render: function() {
        var self = this;
        _.bindAll.apply(_, [self].concat(_.functions(self)));

        if(self.options.workflowDef)
        {
            self.renderWithWorkflow(self.options.workflowDef);
            self.$(".workflow_definition.twistle_dropdown").twistle_dropdown("selectItem", self.options.workflowDef.id);
            self.setTitle(`Start "${self.options.workflowDef.title}" workflow`);
            self.$(".workflow_definition_wrap").hide();
            self.$(".workflow_start_execution_props").css("paddingTop",0);
            if(self.options.workflowExecution)
            {
                // plug in any existing workflow options here (nothing to do right now)
            }
        }
        else
        {
            self.renderAsChooseWorkflow();
        }
        return self;
    },

    renderAsChooseWorkflow: function()
    {
        var self = this;
        if(!self.rendered)
        {
            self.getEl().html(renderTemplate('workflow_start_execution_dialog_template'));

            self.$("input[name=executes_towards_target_date_date]").tws_datePicker();
            self.$("input[name=executes_towards_target_date_time]").timepicker({
                timeFormat: 'g:i a',
                appendTo: self.getEl()
            });

            self.$("input[name=start_on_date_date]").tws_datePicker();
            self.$("input[name=start_on_date_time]").timepicker({
                timeFormat: 'g:i a',
                appendTo: self.getEl()});
            self.$(".test_mode_multiplier.twistle_dropdown").twistle_dropdown();
            self.updateWorkflowChooser(); // see App.WorkflowChooserMixin
            self.reposition();
            self.rendered = true;
            self.$("input.workflow_definition_input").focus();

        }
    },

    workflowDefChosen: function(evt)
    {
        var self = this;
        self.getEl().spin();
        var $targ = $(evt.currentTarget);
        var wfdId = $targ.data("id");
        var wfdOrgId = $targ.data("org-id");
        ajax.request("/workflows/View", {workflow_definition_id: wfdId}, [], function (resp)
        {
            resp.organization = wfdOrgId;

            self.options.workflowDef = new App.WorkflowDefinition(resp).toJSON();
            self.rendered = false;
            self.renderWithWorkflow(self.options.workflowDef);
        });
    },

    renderWithWorkflow: function(wf)
    {
        var self = this;
        if (!self.rendered)
        {
            self.getEl().spin({stop: true});

            var opts = _.extend(self.options, {chosenWorkflow:wf, workflowExecution:self.options.workflowExecution});

            // don't allow batch initiation if we are starting from a specific patient
            opts.can_batch_initiate = !opts.selfEnrollMode && !self.options.model;

            if(!opts.submitButtonText)
            {
                opts.submitButtonText = opts.workflowExecution ? "Modify Workflow" : "Start Workflow";
            }

            self.getEl().html(renderTemplate('workflow_start_execution_dialog_template', opts));

            self.$("input[name=executes_towards_target_date_date]").tws_datePicker();
            self.$("input[name=executes_towards_target_date_time]").timepicker({
                timeFormat: 'g:i a',
                appendTo: self.getEl()});

            self.$("input[name=start_on_date_date]").tws_datePicker();
            self.$("input[name=start_on_date_time]").timepicker({
                timeFormat: 'g:i a',
                appendTo: self.getEl()});
            self.$(".test_mode_multiplier.twistle_dropdown").twistle_dropdown();
            self.validateForm();
            self.reposition();
            self.rendered = true;

            if (opts.can_batch_initiate) {
                self.$(".template_upload_button").twistle_attachments({
                    useWrap:true,
                    isMultiple:false,
                    fileListUi:self.$(".spreadsheet_upload_file"),
                    uploadUrl: "/util/ParseWorkflowSpreadsheet",
                    uploadFileName: "spreadsheet_file",
                    upload_success: self.batchUploadSuccess,
                    additionalUploadParams: [["organization_id", self.options.workflowDef.organization]]
                });
            }

        }
    },

    validateForm: function (evt)
    {
        var self = this,
            isValid,
            hasDefaultActors,
            workflowDefId,
            workflowDef;

        workflowDef = self.options.workflowDef;
        workflowDefId = workflowDef && workflowDef.id;

        if(self.workflowDefId !== workflowDefId)
        {
            self.workflowDefId = workflowDef.id;

            const shouldDefaultToTestMode = !workflowDef.version_live && !self.options.workflowExecution;
            self.$("input[name=test_mode]").prop("checked", shouldDefaultToTestMode);
            self.$(".test_mode_multiplier_wrap").toggle(shouldDefaultToTestMode);
            self.$(".test_mode_diagnostics_wrap").toggle(shouldDefaultToTestMode);
            self.$(".workflow_test_mode_wrap").toggle(workflowDef.allow_test_mode || !workflowDef.version_live);

            if(workflowDef.executes_relative_to_target_date) {
                self.$(".workflow_executes_towards_target_date_wrap").show();
                self.$(".workflow_executes_towards_target_date_wrap label.target_date_label").text(workflowDef.target_date_label);
            }
            else if(workflowDef.start_on_date) {
                self.$(".workflow_start_on_date_wrap").show();
                self.$(".workflow_start_on_date_wrap label.start_date_label").text(workflowDef.start_date_label);
            }
            else {
                self.$(".workflow_executes_towards_target_date_wrap").hide();
                self.$(".workflow_start_date_wrap").hide();

            }

            // tracks which actors are chosen
            self.actors = {};

            // self enroll mode eliminates actor selection (all non-target actors must be defaulted
            if(self.options.selfEnrollMode)
            {
                _.each(workflowDef.workflow_actors,function(actor){
                    if(actor.target)
                    {
                        self.actors[actor.identifier] = self.model.get("username");
                        self.options.targetActorIdentifier = actor.identifier;
                    }
                });
            }
            else
            {
                self.$(".workflow_actor_props").empty().html(
                    renderTemplate('workflow_start_execution_actors_template', workflowDef)
                );
                self.$(".workflow_activity_props").empty().html(
                    renderTemplate('workflow_start_execution_activities_template', workflowDef)
                );

                self.contactLookupList = new App.ContactList();
                self.contactLookupList.fetchFromServer = true;

                self.$(".workflow_definition_actor_input").autocomplete({
                    source: function (request, response)
                    {
                        var fetchParams = {
                            term: request.term,
                            include_network: true,
                            include_self: true,
                            accounttype: "uri",
                            org_ids: App.account.getDefaultOrg()?.id || workflowDef.organization
                        };

                        self.contactLookupList.fetch({
                            reset: true,
                            data: $.param(fetchParams),
                            params: fetchParams,
                            success: function ()
                            {
                                var respData = [];
                                self.contactLookupList.each(function (contact)
                                {
                                    // we should also filter results here - as they might have come direct from the server
                                    respData.push(contact);
                                });
                                response(respData);
                            }
                        });
                    },
                    minLength: 0,
                    select: function (event, ui)
                    {
                        $(this).val(ui.item.get("formalname"));
                        self.actors[$(this).data("identifier")] = ui.item.get("username");
                        event.preventDefault();
                        self.validateForm(event);
                        return false;
                    },
                    focus: function (event, ui)
                    {
                        return false;
                    }
                });

                self.$(".workflow_definition_actor_input").each(function (idx, el)
                {
                    $(el).data("ui-autocomplete")._renderMenu = function (ul, items)
                    {
                        $(items).each(function (idx, val)
                        {
                            var contact = val.toJSON();
                            contact.network_count = 0; //suppress and "via xx and x others";
                            let contactListItemTpl = renderTemplate('contact_list_item_template', contact);
                            var $item = $("<a class='contact workflow_selector_contact'></a>").html(contactListItemTpl);
                            $("<li class='autopeople workflow_selector_contact_wrap'></li>").append($item).data("ui-autocomplete-item", val).appendTo(ul);
                        });
                        postRenderImages(ul);
                    };
                });

                if(self.model) // we were given a contact object as the assumed target actor
                {
                    _.each(workflowDef.workflow_actors,function(actor){
                        if(actor.target)
                        {
                            self.$("input[name=workflow_definition_actor_" + actor.id + "]").val(self.model.get("formalname"));
                            self.actors[actor.identifier] = self.model.get("username");
                        }
                     });
                }

                _.each(workflowDef.workflow_actors,function(actor){
                    if(actor.default || actor.default_to_current_user)
                    {
                        var defaultActor = actor['default_to_current_user'] ? App.account.toJSON() :
                            (shouldDefaultToTestMode ? actor['test_default'] : actor['default']);
                        if (defaultActor) {
                            self.$(".workflow_definition_actor_" + actor.id).hide().addClass("actor_default_hidden");
                            self.$("input[name=workflow_definition_actor_" + actor.id + "]").val(defaultActor.formalname);
                            self.actors[actor.identifier] = defaultActor.username;
                            hasDefaultActors = true;
                        }
                    }
                    if(actor.target)
                    {
                        self.options.targetActorIdentifier = actor.identifier;
                        self.options.targetActorLabel = actor.label;
                    }
                });

                if (shouldDefaultToTestMode) {
                    self.toggleDefaultActors();
                }

            }

            // we are adjusting a workflow
            if(self.options.workflowExecution)
            {
                _.each(workflowDef.workflow_actors,function(actor){
                    var mappedActorUsername = self.options.workflowExecution.actors[actor.identifier],
                        mappedActor = self.options.workflowExecution.accounts[mappedActorUsername];
                    if(mappedActor)
                    {
                        var $actorInput = self.$("input[name=workflow_definition_actor_" + actor.id + "]");
                        $actorInput.val(mappedActor.formalname);
                        self.actors[actor.identifier] = mappedActor.username;
                        if(actor.target)
                        {
                            $actorInput.prop("readonly", true).prop("disabled", true);
                        }
                    }
                });

                if(workflowDef.executes_relative_to_target_date && self.options.workflowExecution.target_date)
                {
                    let parsedDate = new Date(Date.parse(self.options.workflowExecution.target_date));

                    self.$("input[name=executes_towards_target_date_date]").val(betterFormatDate(parsedDate, "mm/dd/yyyy"));
                    self.$("input[name=executes_towards_target_date_time]").val(betterFormatDate(parsedDate, "h:MM TT"));

                }
                else if(workflowDef.start_on_date && self.options.workflowExecution.start_date) {
                    let parsedDate = new Date(Date.parse(self.options.workflowExecution.start_date));

                    self.$("input[name=start_on_date_date]").val(betterFormatDate(parsedDate, "mm/dd/yyyy"));
                    self.$("input[name=start_on_date_time]").val(betterFormatDate(parsedDate, "h:MM TT"));
                }

                // adjust test mode settings
                if(self.options.workflowExecution.test_mode)
                {
                    var props = self.options.workflowExecution.execution_props || {};
                    self.$("input[name=test_mode]").prop("checked", true);
                    self.$(".test_mode_multiplier_wrap").show();
                    self.$(".test_mode_diagnostics_wrap").show();
                    self.$(".test_mode_multiplier.twistle_dropdown").twistle_dropdown(
                        "selectItem",
                        props.test_mode_multiplier || "");
                    self.$("input[name=test_mode_diagnostics]").prop("checked", props.test_mode_diagnostics || false);
                }

                // also need to capture a reason
                self.$(".workflow_execution_modification_reason_wrap").show();

            }

        }
        else if (workflowDefId && $(evt.currentTarget).get(0) === self.$("input[name=test_mode]").get(0))
        {
            // they turned on/off test mode - switch to the appropriate default actor...
            // if it exists and they haven't changed that actor to something else
            // (when turning *on* test mode, if no test mode default actor exists, leave the actor blank for safety reasons)

            var isTestModeOn = self.$("input[name=test_mode]").is(":checked");
            self.$(".test_mode_multiplier_wrap").toggle(isTestModeOn);
            self.$(".test_mode_diagnostics_wrap").toggle(isTestModeOn);

            _.each(workflowDef.workflow_actors, function (actor) {
                var defaultTestActor = actor['test_default'];
                var defaultActor = actor['default'];
                var setToDefault;
                if (isTestModeOn &&
                    (!defaultActor || !self.actors[actor.identifier] || self.actors[actor.identifier] === defaultActor.username)) {
                    setToDefault = defaultTestActor;
                }
                if (!isTestModeOn && defaultActor &&
                    (!defaultTestActor || self.actors[actor.identifier] === defaultTestActor.username)) {
                    setToDefault = defaultActor;
                }

                if (setToDefault) {
                    self.$("input[name=workflow_definition_actor_" + actor.id + "]").val(setToDefault.formalname);
                    self.actors[actor.identifier] = setToDefault.username;
                }
            });

        }

        var intakeFormOptions;
        if (workflowDef && workflowDef.execute_on_submission_of_form_definition) {
            // don't show the intake form until we have a target actor selected
            var targetActorUsername = self.actors[self.options.targetActorIdentifier];

            if (targetActorUsername &&
                (!self.startExecutionFormSubmissionView ||
                    self.startExecutionFormSubmissionView.options.clientContextUsername !== targetActorUsername)) {

                intakeFormOptions = {
                    formId: workflowDef.execute_on_submission_of_form_definition,
                    fullyPreventDialog: true,
                    asStartWorkflow: self.workflowDefId,
                    clientContextUsername: targetActorUsername,
                    onBeforeReposition: function () {
                        self.reposition();
                    }
                };

                if (self.options.workflowExecution) {
                    intakeFormOptions.submissionId = self.options.workflowExecution.executed_with_form_submission;
                } else {
                    intakeFormOptions.fieldPreselections = workflowDef.previous_execution_submission_field_mapping_for_related_workflow;
                }
            }
        }

        if (self.startExecutionFormSubmissionView) {
            if (intakeFormOptions || !workflowDef.execute_on_submission_of_form_definition) {
                self.startExecutionFormSubmissionView.close();
                self.startExecutionFormSubmissionView = undefined;
            }
        }

        if (intakeFormOptions) {
            self.$(".workflow_form_start_on_execute_wrap").empty().append("<div class='form_view_wrap'></div>");
            intakeFormOptions.el = self.$(".workflow_form_start_on_execute_wrap .form_view_wrap");
            self.startExecutionFormSubmissionView = new App.FormSubmissionDialogView(intakeFormOptions);
        }


        isValid = true;
        self.$(".submit_form").attr("disabled", !isValid);

        self.reposition();

    },

    toggleDefaultActors:function()
    {
        var self = this;
        self.$(".actor_default_hidden").slideToggle();
    },

    handleNextButton:function(evt){
        var self = this;
        self.submitForm(evt);
    },
    useCurrentStartDate:function(){
        var self = this;
        self.$("input[name=start_on_date_date]").tws_datePicker("setDate", new Date());
        self.$("input[name=start_on_date_time]").timepicker("setTime", new Date());
    },
    submitForm:function(evt){
        var self = this,
            workflowDef = self.options.workflowDef;

        if(workflowDef.execute_on_submission_of_form_definition)
        {
            if(self.startExecutionFormSubmissionView)
            {
                var handleFormSubmission;

                handleFormSubmission = function(formDef, submissionResp){
                    self.executeWorkflow(submissionResp.id);
                    App.unbind("app:form_submitted",handleFormSubmission,self);
                };

                App.bind("app:form_submitted",handleFormSubmission, self);

                self.startExecutionFormSubmissionView.submitForm(evt);
            }
        }
        else
        {
            self.executeWorkflow();
        }
    },

    executeWorkflow:function(executionFormSubmissionId)
    {
        var self = this,
            workflowDef = self.options.workflowDef,
            endpoint = "/workflows/Start",
            params = {
                workflow_definition_id: self.workflowDefId,
                organization_id: self.options.workflowExecution?.organization || App.account.getDefaultOrg()?.id || workflowDef.organization
            }, execution_props = {};

        if(!self.options.batch_mode)
        {
            params.actors = JSON.stringify(self.actors);
        }
        else
        {
            endpoint = "/workflows/BatchStart";
            params.base_actors = JSON.stringify(self.actors);
            params.batch_data = JSON.stringify(_.map(self.options.batch_list, function(b){
                return {
                    username:b.username,
                    target_date:b.target_date_time};
            }));
        }

        if(self.$("input[name=test_mode]").is(":checked"))
        {
            params.test_mode = true;
            execution_props.test_mode_multiplier = self.$(".test_mode_multiplier.twistle_dropdown").twistle_dropdown("getValue").value;
            if (self.$("input[name=test_mode_diagnostics]").is(":checked")) {
                execution_props.test_mode_diagnostics = true;
            }
        }

        if(executionFormSubmissionId)
        {
            params.executed_with_form_submission_id = executionFormSubmissionId;
        }

        if(workflowDef.executes_relative_to_target_date)
        {
            params.target_date = convertInputToDateTime(
                self.$("input[name=executes_towards_target_date_date]"),
                self.$("input[name=executes_towards_target_date_time]")
            );
        }

        if(workflowDef.start_on_date)
        {
            params.start_date = convertInputToDateTime(
                self.$("input[name=start_on_date_date]"),
                self.$("input[name=start_on_date_time]")
            );
        }

        if(self.options.workflowExecution)
        {
            params.active_workflow_execution_id = self.options.workflowExecution.id;
            var reason = self.$("textarea[name=workflow_execution_modification_reason]").val();
            if (reason.length === 0) {
                raiseAlert("You must enter a reason for modifying this workflow execution!");
                self.$(".workflow_execution_modification_reason_wrap").focus()
                return;
            }
            params.reason = reason;
        }

        params.execution_props = JSON.stringify(execution_props);

        ajax.request(endpoint, params, [], function(jsonResp) {
            if (self.options.workflowExecution) {
                App.trigger("app:workflow_execution_modified", self.options.workflowExecution.id);
                const title = localize("workflow_start_execution_dialog.notifications.workflow_modified", "Workflow Execution Modified");
                showGrowlDefault(self.options.workflowDef.title, title);
            }
            else {
                App.trigger("app:workflow_execution_started", jsonResp && jsonResp.id, jsonResp);
                const title = localize("workflow_start_execution_dialog.notifications.workflow_started", "Workflow Started");
                showGrowlDefault(self.options.workflowDef.title, title);
            }

            self.$(".detail_next_button").hide();
            self.hide();
        }, false, undefined, self.$(".submit_form"));
    },

    startBatchUpload:function(evt)
    {
        var self = this;

        self.$(".spreadsheet_upload_wrap").slideDown(function(){
            // scroll not necessary anymore...
        });

    },

    batchUploadSuccess:function(evt, resp)
    {
        var self = this,
            $uploadWrap = self.$(".batch_upload_wrap"),
            $tmpTimePicker = self.$("input[name=temp_batch_timepicker]");
        self.$(".spreadsheet_upload_wrap").slideUp();
        $uploadWrap.html('<div class="batch_header">'+ escapeHTML(self.options.targetActorLabel) +' List:</div>').show();
        self.options.batch_mode = true;
        self.options.batch_list = [];
        $tmpTimePicker.timepicker();
        _.each(resp.accounts || [], function(account){
            let contact = new Contact(account).toJSON();
            let tpl = renderTemplate('contact_list_item_template', contact);
            let $account = $("<div></div>").html(tpl).addClass("list_item_contact");

            if(self.options.workflowDef.executes_relative_to_target_date)
            {
                // use a temp, hidden timepicker to stitch date/time obj together and deal w/ timezone
                let targetDateUTC = parseDate(contact.target_date),
                    localTargetDate = new Date(targetDateUTC.getUTCFullYear(),
                        targetDateUTC.getUTCMonth(),
                        targetDateUTC.getUTCDate());
                $tmpTimePicker.timepicker("setTime", contact.target_time);
                contact.target_date_time = betterFormatDate($tmpTimePicker.timepicker("getTime", localTargetDate), "isoUtcDateTimeNoTZ");

                $account.find(".details").append(
                    '<div class="target_date">' + self.options.workflowDef.target_date_label + ": " +
                    formatDate(localTargetDate, "{month}/{date}/{year} ") +
                    contact.target_time.substr(0,5) +
                    '</div>');
            }

            self.options.batch_list.push(contact);
            $account.appendTo($uploadWrap)
        });

        self.$(".workflow_definition_actor_target").hide();
        self.$(".workflow_executes_towards_target_date_wrap").hide();

        postRenderImages($uploadWrap);

    }

});

// mixin wf chooser display helpers
_.extend(App.WorkflowStartExecutionDialogView.prototype, App.WorkflowChooserMixin);
